@if (visible) {
  <div style="position:fixed;top:4px;right:8px;z-index:9999;background:rgba(0,0,0,0.65);color:#fff;font-size:12px;padding:4px 8px;border-radius:4px;font-family:monospace;display:flex;gap:8px;align-items:center;">
    @if (timeLeft) {
      <span>session: {{timeLeft}}</span>
    } @else {
      <span style="opacity:0.5">no session</span>
    }
    @for (minutes of sessionPresets; track minutes) {
      <button
        (click)="setSessionMinutes(minutes)"
        style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#fff;font-size:11px;font-family:monospace;padding:1px 5px;border-radius:3px;cursor:pointer;">
        {{minutes}}m
      </button>
    }
    <button
      (click)="toggle()"
      style="background:none;border:none;color:rgba(255,255,255,0.5);font-size:14px;line-height:1;cursor:pointer;padding:0 2px;"
      title="Hide dev tools">✕</button>
  </div>
} @else {
  <button
    (click)="toggle()"
    style="position:fixed;top:4px;right:8px;z-index:9999;background:rgba(0,0,0,0.4);border:none;color:rgba(255,255,255,0.4);font-size:10px;font-family:monospace;padding:2px 5px;border-radius:4px;cursor:pointer;"
    title="Show dev tools">dev</button>
}
